const getCircularReplacer = () => {
	const seen = new WeakSet<object>();

	return (_key: string, value: unknown) => {
		if (value instanceof Error) {
			return {
				name: value.name,
				message: value.message,
				stack: value.stack,
				...(value as unknown as Record<string, unknown>),
			};
		}

		if (typeof value === "bigint") {
			return value.toString();
		}

		if (typeof value === "function") {
			return `[Function ${value.name || "anonymous"}]`;
		}

		if (value && typeof value === "object") {
			if (seen.has(value as object)) {
				return "[Circular]";
			}
			seen.add(value as object);
		}

		return value;
	};
};

export const serializeErrorForSentry = (value: unknown) => {
	if (typeof value === "string") {
		return value;
	}

	try {
		const serialized = JSON.stringify(value, getCircularReplacer());
		return serialized ?? String(value);
	} catch (error) {
		return `Failed to serialize error payload: ${String(error)}`;
	}
};
